import axiosInstance from "./axiosInstance";

// Get post by ID
export const searchChannel = async (channelName) => {
  const response = await axiosInstance.get(`/youtube/channel?ChannelName=${channelName}`);
  return response.data;
};


